import { render, staticRenderFns } from "./DocumentSuggest.vue?vue&type=template&id=762dbff7&"
import script from "./DocumentSuggest.vue?vue&type=script&lang=js&"
export * from "./DocumentSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports